import { cubicOut } from 'svelte/easing';
import type { TransitionConfig } from 'svelte/types/runtime/transition';

export function height(
    node: HTMLElement,
    { duration = 250, easing = cubicOut, delay = 0 }
): TransitionConfig {
    const style = getComputedStyle(node);
    const targetHeight = parseInt(style.height, 10);
    node.style.marginTop = '0';
    node.style.marginBottom = '0';

    return {
        delay,
        duration,
        easing,
        css: (t: number) => {
            return `
      max-height: ${targetHeight * t}px;
      opacity: ${t};
      overflow: hidden;
      backface-visibility: hidden;
      perspective: 1000px;
      transform: translateZ(0);
      will-change: height;
      `;
        },
    };
}
